import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import {
  GetOrganizationConfiguration,
  GetOrganizationConfigurationVariables,
} from "./__generated__/GetOrganizationConfiguration";

export const GET_ORGANIZATION_CONFIGURATION = gql`
  query GetOrganizationConfiguration($organizationId: String!) {
    organizationConfiguration(organizationId: $organizationId) {
      system {
        arcGisMap {
          authAppId
          portalUrl
        }
        userFileMaxSizeMB {
          sitePhoto
          document
        }
      }
      permitWorkflow {
        readOnly
        permitMustHaveGangMembersToIssue
        geofencingStatus {
          value
          options
        }
        geofencingToleranceMeters
      }
      eightPointCheckList {
        readOnly
        items
        declaration
      }
      permitSubmission {
        readOnly
        preSubmissionDeclarations
        requireSitePhoto
      }
      permitCompletion {
        readOnly
        asBuiltCompletionDeclarations
      }
      permitRequest {
        readOnly
        preRequestDeclarations
        optionToSelectThePermitTeamInThePermitRequest
        requireSitePhoto
      }
      licencing {
        readOnly
        products {
          id
          name
          numberOfUsers
          totalPrice
          licenceType
        }
      }
    }
  }
`;

export function useLazyGetOrganizationConfiguration() {
  const [getOrganizationConfiguration, { loading, error, data }] = useLazyQuery<
    GetOrganizationConfiguration,
    GetOrganizationConfigurationVariables
  >(GET_ORGANIZATION_CONFIGURATION, {
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
  });

  return {
    getOrganizationConfiguration,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
